export const CommentProfile = ({padding, margin, height = 30, width = 30}: any) => {
  return (
    <div style={{width: width, height: height, borderRadius: width/2, background: 'grey', textAlign: 'center', lineHeight: `${width}px`, padding: padding, margin: margin}}>
        U
    </div>
  )
}
